import {
    GET_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL,
    SET_IS_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL,
    GET_TRANSFER_APPROVER_ACTIONS_DATA,
    SET_TRANSFER_APPROVER_ACTIONS_DATA,
    SET_TRANSFER_ORDER_APPROVAL_REQUEST,
    SET_TRANSFER_APPROVAL_REQUEST_OPTION_,
    SET_ASSET_APPROVAL_DATA
} from "./TransferApprovalType"

const getTransferItemAndOrderLevelApproval = (val : any) => ({
    type: GET_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL,
    val
});

const setIsTransferItemAndOrderLevelApproval = (isTransferItemAndOrderLevelApprovalData: any) => ({
    type: SET_IS_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL,
    isTransferItemAndOrderLevelApprovalData: isTransferItemAndOrderLevelApprovalData
});

const getTransferApproverActionData = () => ({
    type: GET_TRANSFER_APPROVER_ACTIONS_DATA,
});

const setTransferApproverActionData = (transferApproverActionData: any) => ({
    type: SET_TRANSFER_APPROVER_ACTIONS_DATA,
    transferApproverActionData: transferApproverActionData
});

const setTransferOrderApprovalRequest = (transferOrderApprovalRequest: any) => ({
    type: SET_TRANSFER_ORDER_APPROVAL_REQUEST,
    transferOrderApprovalRequest: transferOrderApprovalRequest
});

const setTransferApprovalRequestOption = (transferApprovalRequestOption: any) => {
    return {
        type: SET_TRANSFER_APPROVAL_REQUEST_OPTION_,
        transferApprovalRequestOption: transferApprovalRequestOption
    }
}

const setAssetApprovalData = (assetApprovalData: any) => ({
    type: SET_ASSET_APPROVAL_DATA,
    assetApprovalData: assetApprovalData
})

export {
    getTransferItemAndOrderLevelApproval,
    setIsTransferItemAndOrderLevelApproval,
    getTransferApproverActionData,
    setTransferApproverActionData,
    setTransferOrderApprovalRequest,
    setTransferApprovalRequestOption,
    setAssetApprovalData
}
